export const defaultICD10Diagnoses = [
  {
    id: 1,
    code: 'A04.7',
    description: 'C. Diff colitis'
  },
  {
    id: 2,
    code: 'A08.11',
    description: 'Norovirus'
  },
  {
    id: 3,
    code: 'A09',
    description:
      'Infectious gastroenteritis and colitis, unspecified'
  },
  {
    id: 4,
    code: 'A15.0',
    description: 'Tuberculosis of lung'
  },
  {
    id: 5,
    code: 'A37.90',
    description: 'Pertussis'
  },
  {
    id: 6,
    code: 'A41.9',
    description: 'Sepsis'
  },
  {
    id: 7,
    code: 'A49.02',
    description: 'MSSA Bacteremia'
  },
  {
    id: 8,
    code: 'A64',
    description:
      'Unspecified Sexually Transmitted Disease'
  },
  {
    id: 9,
    code: 'B86',
    description: 'Scabies'
  },
  {
    id: 10,
    code: 'D25.9',
    description: 'Leiomyoma'
  },
  {
    id: 11,
    code: 'E039',
    description: 'Hypothyroidism'
  }
];